import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=1274eb7e&"
import script from "./Partners.vue?vue&type=script&lang=ts&"
export * from "./Partners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports